(function() {
  // Načítaj nastavenia z window.GWP_SETTINGS (nastavené cez Liquid v theme.liquid)
  const SETTINGS = window.GWP_SETTINGS || {
    enabled: false,
    giftVariantId: 0,
    collections: [],
    variantIds: [],
    maxQty: 1,
    message: '🎁 Darček k objednávke'
  };

  // Ak nie je enabled alebo nemáme gift produkt, vypni celý script
  if (!SETTINGS.enabled || !SETTINGS.giftVariantId || SETTINGS.giftVariantId === 0) {
    console.log('GWP: Vypnuté alebo nie je vybraný darčekový produkt v nastaveniach témy');
    return;
  }

  console.log('GWP: Aktívne s darčekom variant ID:', SETTINGS.giftVariantId);

  // Pridaj globálne CSS pre skrytie gift controls
  const style = document.createElement('style');
  style.textContent = `
    a[data-button-remove][href*="${SETTINGS.giftVariantId}"],
    a[href*="${SETTINGS.giftVariantId}"][data-button-remove] {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      pointer-events: none !important;
      position: absolute !important;
      height: 0 !important;
      width: 0 !important;
      overflow: hidden !important;
    }
    
    a[href*="${SETTINGS.giftVariantId}"]:not([data-button-remove]) {
      pointer-events: none !important;
      cursor: default !important;
      text-decoration: none !important;
    }
  `;
  document.head.appendChild(style);

  const CONFIG = {
    triggerCollections: SETTINGS.collections.map(c => c.trim()).filter(c => c),
    triggerVariantIds: SETTINGS.variantIds.map(v => parseInt(v)).filter(v => !isNaN(v) && v > 0),
    giftVariantId: SETTINGS.giftVariantId,
    giftLineItemProperties: { _isGift: true },
    maxGiftQty: SETTINGS.maxQty,
    collectionFetchLimit: 250,
    collectionMaxPages: 8
  };

  const triggers = new Set();
  let collectionsLoaded = false;
  let busy = false, lastRun = 0;
  let giftProductId = null;

  const sleep = (ms)=>new Promise(r=>setTimeout(r,ms));
  const isJSON = (t)=>t && (t.trim().startsWith('{') || t.trim().startsWith('['));

  async function getJSON(url, opt={}) {
    const res = await fetch(url, {credentials:'same-origin', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, ...opt});
    const text = await res.text();
    if (!isJSON(text)) throw new Error('Non-JSON response');
    return JSON.parse(text);
  }

  async function loadGiftProductIdOnce() {
    if (giftProductId != null) return;
    try {
      const data = await getJSON(`/variants/${CONFIG.giftVariantId}.json`);
      giftProductId = data?.variant?.product_id || null;
    } catch(e) {
      console.warn('GWP: gift product id unresolved:', e.message);
      giftProductId = null;
    }
  }

  async function loadCollectionsOnce() {
    if (collectionsLoaded) return;
    try {
      for (const handle of (CONFIG.triggerCollections||[])) {
        for (let page=1; page<=CONFIG.collectionMaxPages; page++) {
          const data = await getJSON(`/collections/${handle}/products.json?limit=${CONFIG.collectionFetchLimit}&page=${page}`);
          if (!data.products || !data.products.length) break;
          data.products.forEach(p => triggers.add(p.id));
        }
      }
    } catch(e){ console.warn('GWP: kolekcie sa nepodarilo načítať:', e.message); }
    collectionsLoaded = true;
  }

  const addGift = ()=> fetch('/cart/add.js', {
    method:'POST',
    credentials:'same-origin',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body: JSON.stringify({ items:[{ id: CONFIG.giftVariantId, quantity:1, properties: CONFIG.giftLineItemProperties }] })
  });

  const changeLine = (line, qty)=> fetch('/cart/change.js', {
    method:'POST',
    credentials:'same-origin',
    headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
    body: JSON.stringify({ line, quantity: qty })
  });

  function isTriggerLine(item){
    if (giftProductId && item.product_id === giftProductId) return false;
    return triggers.has(item.product_id) || (CONFIG.triggerVariantIds||[]).includes(item.variant_id);
  }

  async function syncGift(immediate = false) {
    const now = Date.now();
    if (!immediate && (busy || now - lastRun < 300)) return;
    busy = true; lastRun = now;

    let cartChanged = false;

    try {
      await Promise.all([loadCollectionsOnce(), loadGiftProductIdOnce()]);

      const cart = await getJSON('/cart.js');
      const hasTrigger = cart.items.some(isTriggerLine);
      const gi = cart.items.findIndex(it => it.variant_id === CONFIG.giftVariantId);

      if (hasTrigger) {
        if (gi === -1) {
          const r = await addGift();
          if (!r.ok) console.warn('GWP: add failed', r.status);
          else cartChanged = true;
        } else {
          const giftLine = gi + 1;
          const currentQty = cart.items[gi].quantity;
          if (currentQty !== CONFIG.maxGiftQty) {
            await changeLine(giftLine, CONFIG.maxGiftQty);
            cartChanged = true;
          }
        }
      } else if (gi !== -1) {
        await changeLine(gi + 1, 0);
        cartChanged = true;
      }
    } catch(e){
      console.warn('GWP sync error:', e.message);
      await sleep(800);
    } finally {
      busy = false;
      
      if (cartChanged) {
        await refreshCartModal();
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      }
    }
  }

  // Refresh cart modal a cart bubble - OPTIMALIZOVANÉ
  async function refreshCartModal() {
    try {
      const [sectionsRes, cartData] = await Promise.all([
        fetch(`${window.location.pathname}?sections=cart-modal,CartBubble`, { 
          headers: { 'X-Requested-With': 'XMLHttpRequest' }, 
          credentials: 'same-origin' 
        }),
        fetch('/cart.js').then(r => r.json())
      ]);
      
      const htmlMap = await sectionsRes.json();

      if (htmlMap['cart-modal']) {
        const cartModal = document.getElementById('cart-modal');
        if (cartModal) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlMap['cart-modal'], 'text/html');
          const newModal = doc.getElementById('cart-modal');
          if (newModal) {
            cartModal.innerHTML = newModal.innerHTML;
            hideGiftControls(cartData);
          }
        }
      }

      if (htmlMap['CartBubble']) {
        const bubble = document.getElementById('CartBubble');
        if (bubble) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlMap['CartBubble'], 'text/html');
          const newBubble = doc.getElementById('CartBubble');
          if (newBubble) {
            bubble.innerHTML = newBubble.innerHTML;
          }
        }
      }

      const count = cartData.item_count || 0;
      const countElements = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
      countElements.forEach(el => {
        if (el) el.textContent = count;
      });

    } catch(e) {
      console.warn('Cart modal refresh error:', e);
    }
  }

  // Skry quantity a delete tlačidlá pre darček - S OCHRANOU PROTI DUPLICITÁM
  let giftControlsHidden = false;
  
  function hideGiftControls(cartData = null) {
    if (!cartData) {
      fetch('/cart.js')
        .then(r => r.json())
        .then(data => hideGiftControls(data))
        .catch(e => console.warn('Gift check error:', e));
      return;
    }

    giftControlsHidden = false;

    cartData.items.forEach((item, index) => {
      const isGift = item.properties && item.properties._isGift;
      if (!isGift) return;

      const giftVariantId = item.variant_id;
      const allCartItems = document.querySelectorAll('[data-cart-item-index]');
      
      let giftCartItem = null;
      allCartItems.forEach(cartItem => {
        if (cartItem.dataset.giftProcessed === 'true') {
          giftCartItem = cartItem;
          return;
        }
        
        const productLink = cartItem.querySelector(`a[href*="${giftVariantId}"]`);
        if (productLink) {
          giftCartItem = cartItem;
        }
      });

      if (!giftCartItem) {
        return;
      }

      if (giftCartItem.dataset.giftProcessed === 'true') {
        return;
      }
      giftCartItem.dataset.giftProcessed = 'true';

      const deleteLinks = giftCartItem.querySelectorAll(`a[data-button-remove][href*="${giftVariantId}"]`);
      deleteLinks.forEach(link => {
        if (link && link.parentNode) {
          link.remove();
        }
      });

      const productLinks = giftCartItem.querySelectorAll(`a[href*="${giftVariantId}"]:not([data-button-remove])`);
      productLinks.forEach(link => {
        if (link) {
          link.style.pointerEvents = 'none';
          link.style.cursor = 'default';
          link.style.textDecoration = 'none';
          const href = link.getAttribute('href');
          if (href) link.removeAttribute('href');
        }
      });

      const qtySelector = giftCartItem.querySelector('qty-selector');
      if (qtySelector && qtySelector.parentNode) {
        qtySelector.remove();
      }

      const qtyInputs = giftCartItem.querySelectorAll('input[type="number"], button[aria-label*="-"], button[aria-label*="+"]');
      qtyInputs.forEach(el => {
        if (el && el.parentNode) {
          el.remove();
        }
      });
    });
  }
  
  // HOOKY - okamžité spustenie na cart change
  document.addEventListener('DOMContentLoaded', ()=> {
    setTimeout(syncGift, 200);
    setTimeout(hideGiftControls, 300);
  });
  
  document.addEventListener('submit', (e)=>{
    const form = e.target;
    if (form && form.matches('form[action*="/cart/add"]')) {
      setTimeout(() => {
        syncGift();
        setTimeout(() => refreshCartModal(), 400);
      }, 250);
    }
  }, true);
  
  document.addEventListener('click', (e)=>{
    const btn = e.target.closest('button[name="add"], [data-add-to-cart], .product-form__submit');
    if (btn) {
      setTimeout(() => {
        syncGift();
        setTimeout(() => refreshCartModal(), 400);
      }, 250);
    }
    
    const modalTrigger = e.target.closest('modal-trigger[target="#cart-modal"], [data-cart-drawer-toggle]');
    if (modalTrigger) setTimeout(hideGiftControls, 100);
  });
  
  document.addEventListener('change', (e)=>{
    if (e.target && (e.target.name === 'updates[]' || e.target.closest('[data-cart]'))) {
      setTimeout(() => syncGift(true), 50);
    }
  });
  
  document.addEventListener('click', (e)=>{
    const deleteBtn = e.target.closest('[data-cart-item-remove], .cart-item__remove, [aria-label*="Odstrániť"], [aria-label*="Remove"]');
    if (deleteBtn) {
      setTimeout(() => syncGift(true), 100);
    }
  }, true);
  
  const _fetch = window.fetch;
  window.fetch = function() {
    const url = (arguments[0] && arguments[0].toString()) || '';
    const p = _fetch.apply(this, arguments);
    if (/(\/cart\/add\.js|\/cart\/change\.js|\/cart\/update\.js)$/.test(url)) {
      p.finally(()=> {
        setTimeout(() => syncGift(true), 150);
        setTimeout(() => refreshCartModal(), 300);
      });
    }
    return p;
  };
})();